export const themeConstants = {
    //set theme
    UPDATE_THEME: 'UPDATE_THEME',
};